import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { OverlayTrayService } from './overlay-tray.service';

@Component({
  selector: 'z-overlay-tray',
  templateUrl: './overlay-tray.feature.html',
  styleUrl: './overlay-tray.feature.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule
  ]
})
export class OverlayTrayFeature {
  tray = inject(OverlayTrayService);
}
